import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import IndustrySearch from "../../components/industry-search/component";
import Faq from "../../components/faq/component";
import ErrorHandler from "../../components/error-handler/component";
import {tokenRegister} from "../../services/tokenRegister";
import {industriesRegister} from "../../services/industriesRegister";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {scraperRegister} from "../../services/scraperRegister";
import ModalImageSize from "../../components/modal-imagesize/component";
import ModalCoupon from "../../components/modal-coupon/component";
import ModalCropp from "../../components/modal-cropp/component";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";
import queryString from "query-string";
import ModalImageError from "../../components/modal-imageerror/component";

class SignupImage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            image: null,
            images: [],
            uploaded_images: [],
            scraped_images: [],
            isLoadingButton: false,
            isLoading: true,
            page: 0,
            uploaded_image: null,
            uploaded_image_url: null,
            admin: false,
            error: false,
            industries: [],
            hideButton: false,
            src: null
        };
        this.functions.removeSizeModal = this.functions.removeSizeModal.bind(this);
        this.functions.setImageSrc = this.functions.setImageSrc.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this.update.user();
        this.update.data();
        this.update.image();
        this.update.video();
        this.functions.selectIndustry = this.functions.selectIndustry.bind(this);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/signup/image');
            ReactGA4.send({ hitType: "pageview", page: "/signup/image" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    update = {
        user: () => {
            try {
                let user = userRegister.get();
                if (user) {
                    this.setState({admin: user.reseller || user.inhouse, inhouse: user.inhouse});
                }
            } catch (error) {
                this.setState({
                    error: true
                });
            }
        },
        data: (updated_industry, industry) => {
            try {
                let stored_data = cartRegister.get();
                if (updated_industry) {
                    stored_data.industry = industry;
                }
                if (stored_data.industry) {
                    this.setState({
                        industry: stored_data.industry
                    }, () => {
                        this.update.images(this.state.industry.id, updated_industry);
                    });
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'));
                }

            } catch (error) {
                this.setState({error: true});
            }
        },
        video: () => {
              try{
                  let stored_video = cartRegister.get();
                  if(stored_video.admin_video && stored_video.admin_video_thumbnail){
                      this.setState({
                          uploaded_video: {url: stored_video.admin_video, thumbnail: stored_video.admin_video_thumbnail},
                          video_selected: true
                      })
                  }
              }catch (e) {

              }
        },
        image: () => {
            try {
                let stored_image = cartRegister.get();
                if (stored_image.admin_image) {
                    try {
                        if (stored_image.admin_image) {
                            if (stored_image.admin_image.url) {
                                stored_image.admin_image.selected = true;
                                this.state.uploaded_images.push(stored_image.admin_image);
                                this.setState({uploaded_images: this.state.uploaded_images});
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (stored_image.image) {
                    this.setState({
                        image: stored_image.image.id
                    });
                }
            } catch (error) {
                this.setState({error: true});
            }
        },
        images: (industry, updated) => {
            try {
                let stored_images = imagesRegister.get();
                let stored_page = imagesRegister.page();
                if (updated) {
                    stored_images = [];
                }
                if (stored_images.length > 0) {
                    this.setState({
                        images: stored_images ? stored_images : [],
                        page: stored_page,
                        isLoading: false
                    });
                } else {
                    this.setState({images: []}, () => {
                        let image_amount = 3;
                        dataRegister.images({
                            industry: industry,
                            market: salesChannelRegister.get("market"),
                            page: this.state.page,
                            amount: this.state.admin ? 2 : image_amount
                        }).then((data) => {
                            if (!data.errors) {
                                if (this.state.page === 0 && data.length < 1) {
                                    if (!this.state.admin) {
                                        this.setState({isLoading: false, modal: true});
                                    } else {
                                        this.setState({isLoading: false});
                                    }
                                } else {
                                    let page = 0;
                                    if (image_amount > 5) {
                                        page = this.state.page + 2;
                                    } else {
                                        page = this.state.page + 1;
                                    }
                                    let images = data;
                                    imagesRegister.set(images, page);
                                    this.setState({
                                        images: images,
                                        page: page
                                    }, () => {
                                        this.setState({isLoading: false});
                                    });
                                }
                            } else {
                                if (!this.state.admin) {
                                    this.setState({isLoading: false, modal: true});
                                } else {
                                    this.setState({isLoading: false});
                                }
                            }
                        }, (error) => {
                            if (!this.state.admin) {
                                this.setState({isLoading: false, modal: true});
                            } else {
                                this.setState({isLoading: false});
                            }
                        });
                    });
                }
            } catch (error) {
                this.setState({error: true});
            }
        }
    };

    functions = {
        scroll: (element) => {
            let offSet = 0, timeout = null;
            element = document.getElementById(element);
            if (element) {
                const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
                window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
            }
        },
        selectIndustry: (value) => {
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            this.setState({page: 0, uploaded_images: [], error: false, removeLoadMore: false,}, () => {
                cartRegister.setIndustry(value);
                this.update.data(true, value);
            });
        },
        selectImage: (prop) => {
            try {
                if (!this.state.isSelecting) {
                    this.setState({isSelecting: true}, () => {
                        let image = this.state.image;
                        this.setState({
                            image: prop.id,
                            image_preview: prop.preview,
                        }, () => {
                            setTimeout(() => {
                                let image_object = {
                                    url: prop.preview,
                                    id: prop.id,
                                    file: null,
                                    description: ""
                                };
                                try {
                                    let stored_data = cartRegister.get();
                                    if (stored_data.image.id !== prop.id) {
                                        videoRegister.remove();
                                        carouselRegister.remove();
                                    }
                                } catch (e) {
                                    videoRegister.remove();
                                    carouselRegister.remove();
                                }
                                imagesRegister.setImages(this.state.images, this.state.page);
                                cartRegister.setImage(image_object);

                                /*
                                if(this.state.video_selected && this.state.uploaded_video){
                                    cartRegister.setAdminVideo(this.state.uploaded_video);
                                }else{
                                    cartRegister.setAdminVideo({url: null, thumbnail: null});
                                }
                                */

                                if(this.state.inhouse){
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/video");
                                }else{
                                    let view = quotesRegister.getView();
                                    if (view === "custom") {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes-custom");
                                    } else {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes");
                                    }
                                }
                            }, 200);
                        });
                    });
                }
            } catch (error) {
                console.log(error);
                this.setState({error: true});
            }
        },
        selectUploadedImage: (item) => {
            try {
                if (item.isValid) {
                    try {
                        let stored_data = cartRegister.get();
                        if (stored_data.admin_image.date !== item.date) {
                            videoRegister.remove();
                            carouselRegister.remove();
                        }
                    } catch (e) {
                        videoRegister.remove();
                        carouselRegister.remove();
                    }
                    cartRegister.setAdminImage(item);
                    /*
                    if(this.state.video_selected && this.state.uploaded_video){
                        cartRegister.setAdminVideo(this.state.uploaded_video);
                    }else{
                        cartRegister.setAdminVideo({url: null, thumbnail: null});
                    }
                    */
                    this.setState({isLoading: true});
                    if(this.state.inhouse){
                        setTimeout(() => {
                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/video");
                        }, 200);
                    }else{
                        setTimeout(() => {
                            let view = quotesRegister.getView();
                            if (view === "custom") {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes-custom");
                            } else {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes");
                            }
                        }, 200);
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        uploadImage: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    if (e.target.files[0].size > 5999000) {
                        this.setState({size_modal: true});
                    } else {
                        const reader = new FileReader();
                        reader.addEventListener("load", () => {
                            this.setState({temp_src: reader.result, cropp_modal: true});
                        });
                        reader.readAsDataURL(e.target.files[0]);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        uploadVideo: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    if (e.target.files[0].size > 5999000) {
                        this.setState({size_modal: true});
                    } else if(e.target.files[0].type === 'video/mp4') {
                        this.functions.addVideo(e.target.files[0]);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        addVideo: (file) => {
            this.setState({
                loading_video: true
            }, () => {
                let files = new FormData();
                files.append('file', file);
                dataRegister.uploadVideo(files).then((response) => {
                    this.setState({uploaded_video: response, loading_video: false, video_selected: true}, () => {

                    });
                }, (error) => {
                    this.setState({
                        loading_video: false,
                        error_modal: true,
                    })
                });
            });
        },
        addCroppedImage: () => {

            let item = this.refs.cropper.getCroppedCanvas().toDataURL('image/jpeg');
            let image_object = {
                url: null,
                data_url: item,
                date: Math.floor(Math.random() * 999999999999999999999),
                description: "",
                isAnalyzing: true,
                isValid: false
            };
            this.state.uploaded_images.unshift(image_object);
            this.setState({uploaded_images: this.state.uploaded_images, src: null}, () => {
                let files = new FormData();
                files.append('image', this.functions.dataURItoBlob(item));
                dataRegister.analyzeImage(files).then((response) => {
                    for (let i = 0; i < this.state.uploaded_images.length; i++) {
                        if (image_object.date === this.state.uploaded_images[i].date) {
                            this.state.uploaded_images[i].isAnalyzing = false;
                            this.state.uploaded_images[i].isValid = response.valid;
                            this.state.uploaded_images[i].url = response.url;
                            this.state.uploaded_images[i].images = response.images;
                        }
                    }
                    this.setState({uploaded_images: this.state.uploaded_images});
                }, (error) => {
                    this.setState({src: null}, () => {
                    });
                });
            });
        },
        setImageSrc: (option, close) => {
            if (!close) {
                if (!option) {
                    this.setState({cropp_modal: false}, () => {
                        setTimeout(() => {
                            this.setState({src: this.state.temp_src});
                        }, 300);
                    });
                } else {
                    let image_object = {
                        url: null,
                        data_url: this.state.temp_src,
                        date: Math.floor(Math.random() * 999999999999999999999),
                        description: "",
                        isAnalyzing: true,
                        isValid: false
                    };
                    this.state.uploaded_images.unshift(image_object);
                    this.setState({uploaded_images: this.state.uploaded_images, src: null, cropp_modal: false}, () => {
                        let files = new FormData();
                        files.append('image', this.functions.dataURItoBlob(this.state.temp_src));
                        dataRegister.analyzeImage(files).then((response) => {
                            for (let i = 0; i < this.state.uploaded_images.length; i++) {
                                if (image_object.date === this.state.uploaded_images[i].date) {
                                    this.state.uploaded_images[i].isAnalyzing = false;
                                    this.state.uploaded_images[i].isValid = response.valid;
                                    this.state.uploaded_images[i].url = response.url;
                                    this.state.uploaded_images[i].images = response.images;
                                }
                            }
                            this.setState({uploaded_images: this.state.uploaded_images, temp_src: null});
                        }, (error) => {
                            this.setState({src: null, temp_src: null}, () => {
                            });
                        });
                    });
                }
            } else {
                this.setState({temp_src: null, cropp_modal: false});
            }
        },
        dataURItoBlob: (dataURI) => {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type: mimeString});
        },
        moreImages: () => {
            if (!this.state.isLoadingButton && !this.state.removeLoadMore) {
                this.setState({
                    isLoadingButton: true
                });
                dataRegister.images({
                    industry: this.state.industry.id,
                    market: salesChannelRegister.get("market"),
                    page: this.state.page,
                    amount: 3
                }).then((data) => {
                    if (!data.errors) {
                        let page = this.state.page + 1;
                        let images = this.state.images.concat(data);
                        imagesRegister.set(images, page);
                        this.setState({
                            images: images,
                            isLoadingButton: false,
                            page: page,
                            removeLoadMore: data.length < 3
                        }, () => {
                            this.functions.scroll("bottom");
                        });
                    } else {
                        this.setState({
                            isLoadingButton: false,
                            removeLoadMore: true
                        });
                    }
                }, (error) => {
                    this.setState({
                        isLoadingButton: false,
                        removeLoadMore: true
                    });
                });
            }
        },
        removeSizeModal: () => {
            this.setState({size_modal: false})
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-image", item);
        },
        uploadedImage: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div className={cx(Styles.imagesContainerItemPadding)}>
                        {
                            item.isAnalyzing &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div className={Styles.imagesContainerItemOverlayText}>
                                    <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                                    <div
                                        className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_37")}</div>
                                </div>
                            </div>
                        }
                        {
                            !item.isAnalyzing && !item.isValid && !item.error &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div
                                    className={cx(Styles.imagesContainerItemOverlayText, Styles.imagesContainerItemOverlayTextError)}>
                                    {this.renders.text("item_38")}
                                </div>
                            </div>
                        }
                        {
                            !item.isAnalyzing && item.error &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div
                                    className={cx(Styles.imagesContainerItemOverlayText, Styles.imagesContainerItemOverlayTextError)}>
                                    {this.renders.text("item_39")}
                                </div>
                            </div>
                        }
                        <div onClick={() => this.functions.selectUploadedImage(item)} className={cx(Styles.imagesContainerItemInner)}>
                            {
                                item.url &&
                                <div style={{backgroundImage: "url(" + item.url + ")"}}
                                     className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)}/>
                            }
                            {
                                !item.url &&
                                <div style={{backgroundImage: "url(" + item.data_url + ")"}}
                                     className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)}/>
                            }
                            {
                                item.selected &&
                                <div className={Styles.imagesContainerItemActive}/>
                            }
                        </div>
                    </div>
                </div>
            )
        },
        uploadedVideo: () => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div className={cx(Styles.imagesContainerItemPadding)}>
                        {
                            this.state.loading_video &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div className={Styles.imagesContainerItemOverlayText}>
                                    <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                                    <div
                                        className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_41")}</div>
                                </div>
                            </div>
                        }
                        {
                            this.state.uploaded_video &&
                            <div onClick={() => {
                                this.setState({
                                    video_selected: !this.state.video_selected
                                })
                            }} className={cx(Styles.imagesContainerItemInner)}>
                                {
                                    this.state.uploaded_video.url && false &&
                                    <div style={{backgroundImage: "url(" + this.state.uploaded_video.thumbnail + ")"}}
                                         className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)}/>
                                }
                                {
                                    this.state.uploaded_video.url &&
                                    <video loop={true} muted={true} autoPlay={true} controls={false} style={{width: '100%', height: '100%'}}>
                                        <source src={this.state.uploaded_video.url} type="video/mp4"/>
                                    </video>
                                }
                                {
                                    this.state.video_selected &&
                                    <div className={Styles.imagesContainerItemActive}/>
                                }
                            </div>
                        }
                    </div>
                </div>
            )
        },
        uploadButton: () => {
            return (
                <div className={
                    cx(Styles.imagesContainerItem,
                        {
                            [Styles.imagesContainerItemCenter]: false,
                        })
                }>
                    <div className={Styles.imagesContainerItemPadding}>
                        <div className={Styles.imagesContainerItemInner}>
                            {
                                this.state.admin && !this.state.uploaded_image &&
                                <div className={Styles.imagesContainerItemInnerIconContainer}>
                                    <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                                    {
                                        false &&
                                        <div className={Styles.imagesContainerItemInnerIconText}>
                                            Upload image
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        {
                            <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                                   onChange={(e) => this.functions.uploadImage(e)} type="file"
                                   accept="image/jpeg, image/png"
                                   className={Styles.imagesContainerItemInnerUpload}/>
                        }
                    </div>
                </div>
            )
        },
        uploadVideoButton: () => {
            return (
                <div className={
                    cx(Styles.imagesContainerItem,
                        {
                            [Styles.imagesContainerItemCenter]: false,
                        })
                }>
                    <div className={Styles.imagesContainerItemPadding}>
                        <div className={Styles.imagesContainerItemInner}>
                            {
                                this.state.admin && !this.state.uploaded_video &&
                                <div className={Styles.imagesContainerItemInnerIconContainer}>
                                    <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                                    {
                                        false &&
                                        <div className={Styles.imagesContainerItemInnerIconText}>
                                            Upload video
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        {
                            <input ref="uploadVideoFile" onClick={() => this.refs.uploadVideoFile.value = null}
                                   onChange={(e) => this.functions.uploadVideo(e)} type="file"
                                   accept="video/mp4"
                                   className={Styles.imagesContainerItemInnerUpload}/>
                        }
                    </div>
                </div>
            )
        }
    };

    render() {
        return (
            <div>
                <HeaderSignupOne history={this.props.history} view={"signup"} props={this.props}/>
                {
                    this.state.size_modal &&
                    <ModalImageSize setLeave={this.functions.removeSizeModal}/>
                }
                {
                    this.state.error_modal &&
                    <ModalImageError setLeave={this.functions.removeSizeModal}/>
                }
                {
                    this.state.cropp_modal &&
                    <ModalCropp setLeave={this.functions.setImageSrc}/>
                }
                {
                    this.state.modal &&
                    <div className={Styles.overlay}>
                        <div className={Styles.overlayModal}>
                            <div className={Styles.overlayModalInner}>
                                <img
                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'))}
                                    className={Styles.overlayCloseButton}
                                    src={require("../../assets/images/close_icon.svg")}/>
                                <div>
                                    <div className={Styles.overlayModalTitle}>
                                        {this.renders.text("item_9")}
                                    </div>
                                    <div className={Styles.overlayModalText}>
                                        <span
                                            className={Styles.overlayModalTextBold}>{this.renders.text("item_8")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.overlayModalButtons}>
                                <div className={Styles.overlayModalButtonsItem}>
                                    <div
                                        onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'))}
                                        className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                        ok
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.src &&
                    <div className={Styles.overlayCopper}>
                        <div className={Styles.overlayModalCrop}>
                            {
                                <Cropper
                                    ref='cropper'
                                    modal={false}
                                    src={this.state.src}
                                    style={{height: 400, width: '100%'}}
                                    aspectRatio={300 / 157}
                                    guides={false}
                                    background={false}
                                    zoomOnWheel={false}
                                    viewMode={1}
                                    dragMode={'none'}
                                />
                            }
                            <div className={Styles.overlayModalCropButtons}>
                                <div className={Styles.overlayModalCropButtonsInner}>
                                    <div onClick={() => {
                                        this.setState({src: null})
                                    }} className={Styles.overlayModalCropButtonsItemRemove}>
                                        <img className={Styles.overlayModalCropButtonsItemRemoveIcon}
                                             src={require("../../assets/images/AB_cross_bold.png")}/>
                                    </div>
                                    <div onClick={() => this.functions.addCroppedImage()}
                                         className={Styles.overlayModalCropButtonsItemSelect}>
                                        <img className={Styles.overlayModalCropButtonsItemSelectIcon}
                                             src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            {
                                !this.state.error &&
                                <div className={Styles.subtitleContainer}>
                                    <IndustrySearch selectIndustry={this.functions.selectIndustry}
                                                    industry={this.state.industry} industries={this.state.industries}/>
                                </div>
                            }
                            {
                                !this.state.modal &&
                                <div className={
                                    cx(Styles.imagesContainer,
                                        {
                                            [Styles.imagesContainerCenter]: this.state.uploaded_images.length < 1 && this.state.images.length < 1 && this.state.admin,
                                        })
                                }>
                                    {
                                        this.state.admin && this.state.industry &&
                                        this.renders.uploadButton()
                                    }
                                    {
                                        false && this.state.admin && this.state.industry && !this.state.loading_video && !this.state.uploaded_video &&
                                        this.renders.uploadVideoButton()
                                    }
                                    {
                                        false && this.state.admin && this.state.industry && ( this.state.loading_video || this.state.uploaded_video )  &&
                                        this.renders.uploadedVideo()
                                    }
                                    {
                                        this.state.uploaded_images.map((item) => {
                                            return (
                                                this.renders.uploadedImage(item)
                                            )
                                        })
                                    }
                                    {
                                        this.state.images.map((prop, i) => {
                                            return (
                                                <div key={i} className={Styles.imagesContainerItem}>
                                                    <div className={Styles.imagesContainerItemPadding}>
                                                        <div onClick={() => this.functions.selectImage(prop)}
                                                             style={{backgroundImage: "url(" + prop.preview + ")"}}
                                                             className={Styles.imagesContainerItemInner}>
                                                            {
                                                                this.state.image === prop.id &&
                                                                <div className={Styles.imagesContainerItemActive}/>
                                                            }
                                                        </div>
                                                        <div className={Styles.imagesContainerItemLoader}>
                                                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                            {
                                this.state.industry && !this.state.modal && this.state.images.length > 0 &&
                                <div onClick={() => this.functions.moreImages()} className={
                                    cx(Styles.plusIcon,
                                        {
                                            [Styles.plusIconActive]: !this.state.removeLoadMore,
                                        })
                                }>
                                    {
                                        this.state.isLoadingButton &&
                                        <BeatLoader size={12} color={'#ffffff'} loading={true}/>
                                        ||
                                        <img className={Styles.plusIconItem}
                                             src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    }
                                </div>
                            }
                            {
                                this.state.industry && !this.state.modal && (this.state.images.length > 0 || this.state.admin || this.state.uploaded_images.length > 0) &&
                                <div
                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/crossroad")}
                                    className={
                                        cx(Styles.backButton,
                                            {
                                                [Styles.backButtonCenter]: (this.state.images.length > 0 || (this.state.images.length < 1 && this.state.uploaded_images.length < 1)),
                                            })
                                    }>
                                    {this.renders.text("item_29")}
                                </div>
                            }
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default SignupImage;


// WEBPACK FOOTER //
// ./src/pages/signup-image/component.js